import React, { useEffect, useState } from 'react'
import './error.css'
function ErrorPage() {
    const [delay, setDelay] = useState(false)
    useEffect(() => {
        setTimeout(() => setDelay(true), 1500)
    }, [])
    return (
        <>
            {delay ?
                <div className='text-primary siteError'>
                    <div className="sketchError">
                        <div className="bee-sketchError redError"></div>
                        <div className="bee-sketchError blueError"></div>
                    </div>
                    <div className='h1Error'>404:
	                    <small className='text-primary m-2'>Page doesn't exist. </small>
                        <h5 className='mb-5'>
                            This page does not exist or has been deleted from the site.
                           <div>
                                <a style={{ textDecoration: 'underline' }} href='/'> Redirect to Home</a>
                            </div>
                        </h5>
                    </div>

                </div>
                :
                <div></div>
            }
        </>
    )
}

export default ErrorPage
